import { ChangeDetectionStrategy, Component, computed, inject, OnDestroy, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { VenueDetailsService } from '../venue-details.service';
import { Subject, takeUntil } from 'rxjs';
import { SelectUserComponent } from '../../../_shared/components/select-user/select-user.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-venue-admins',
  templateUrl: './venue-admins.component.html',
  styleUrls: ['./venue-admins.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonicModule,
    TranslateModule
  ]
})
export class VenueAdminsComponent implements OnDestroy {
  private venueDetailsService = inject(VenueDetailsService);
  private modalController = inject(ModalController);
  venue = computed(() =>this.venueDetailsService.venue());
  selectedAdmins: string[] = [];


  private readonly destroy$: Subject<void> = new Subject();

  constructor() {
    this.venueDetailsService.venueWithAddedAdmin$
      .pipe(takeUntil(this.destroy$))
      .subscribe()

    this.venueDetailsService.venueWithDeletedAdmin$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.selectedAdmins = [];
      })
  }

  async ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectAdmins(ev, _adminId) {
    if (ev.detail.checked) {
      this.selectedAdmins.push(_adminId)
    } else {
      const index = this.selectedAdmins.findIndex(sa => sa === _adminId);
      this.selectedAdmins.splice(index, 1)
    }
  }

  isAdminChecked(_adminId: string) {
    return this.selectedAdmins.some(sa => sa === _adminId)
  }

  async addAdminByPhone() {
    const modal = await this.modalController.create({
        component: SelectUserComponent
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
        let phone = data.phone ? data.country_code + data.phone : "";
        let email = data.email;        
        this.venueDetailsService.addAdmin$.next({ phone, email })
      }
  }

  async deleteAdmins() {
    this.venueDetailsService.deleteAdmins$.next({ _adminIds: this.selectedAdmins })
  }

}
